<!-- loader -->
<!--<div [@fade]="(isLoading$ | async)" class="preloader">
  <div class="load-list">
    <img src="assets/xemart/loading.gif" style="height: 70px; width: 70px;">
  </div>
</div>-->
<!-- loader -->
<app-topbar></app-topbar>
<router-outlet></router-outlet>
